import React from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./contact.css";
import { Container } from "react-bootstrap";

const Contact = () => {
  return (
    <div id="contact">
      <h1 className="pt-3 text-center font-details pb-2">CONTACTO</h1>
      <Jumbotron className="contact-jumbotron">
        <Container>
          <Row>
            <Col md={6}>
              <div className="contact-copy">
                <h2 className="mb-3">¡Únete a nuestra comunidad!</h2>
                <p className="lead mb-3">
                  Inscríbete hoy y sé parte del cambio. Juntos podemos mejorar la calidad de vida de quienes viven con drepanocitosis y sus familias.
                </p>
                <p className="mb-3">
                  Nos encantaría saber de ti. Si tiene dudas o preguntas escríbenos. Estamos aquí para ayudarte.
                </p>
                <p className="text-muted mb-0 small">
                  Este es un proyecto implementado con el apoyo experto y financiero del St. Jude Children Research Hospital y la Asociación de caridad Americana - Libanesa - Siria (ALSAC)
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="contact-actions d-flex flex-wrap justify-content-md-end justify-content-start">
                <a
                  href="mailto:drepanocitico@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mr-2 mb-2"
                >
                  <Button variant="outline-danger" title="drepanocitico@gmail.com">
                    <i className="fas fa-envelope-square"></i> Correo
                  </Button>
                </a>

                <a
                  href="https://www.instagram.com/drepanocitico_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mb-2"
                >
                  <Button variant="outline-info" title="Síguenos en Instagram">
                    <i className="fab fa-instagram"></i> Instagram
                  </Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
    </div>
  );
};

export default Contact;
